import BusinessDevelopment from "../pages/Dashboards/BusinessDevelopment";
import ClientService from "../pages/Dashboards/ClientService";
import CustomerService from "../pages/Dashboards/CustomerService";

export default [
  {
    department: "Business Development",
    component: BusinessDevelopment,
  },
  {
    department: "Client Service",
    component: ClientService,
  },
  {
    department: "Customer Service",
    component: CustomerService,
  },
];
